<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiAlertCircle } from "@mdi/js";
export default {
  name: "MdiAlertCircle",
  data() {
    return {
      svgPath: mdiAlertCircle,
    };
  },
};
</script>
